import styled from '@emotion/styled'
import { colors } from '../../../../__styling/settings/colors'
import { fonts } from '../../../../__styling/settings/fonts'
import { breakpoint } from '../../../../__styling/style-functions'
import { calcRem } from '../../../../__styling/style-functions/calc-rem'

export const SponsorshipWrapper = styled('div')({
    height: calcRem(40),
    width: calcRem(120),
    overflow: 'hidden',

    [breakpoint('sm')]: {
        height: calcRem(54),
        width: 'auto',
    },
})

export const SponsorshipText = styled('p')({
    fontFamily: fonts.thewest.sansSerifCond,
    color: colors.white,
    fontSize: calcRem(9),
    fontWeight: 'normal',
    margin: `0 0 ${calcRem(2)} 0`,
})

export const SponsorshipImage = styled('img')({
    display: 'block',
    height: '100%',
})
